import React, { useCallback, useEffect, useState } from 'react';
import _, { isArray, noop } from 'lodash';
import { Button } from 'antd';
import CustomSelect from './CustomSelect';
import ProductAPI from 'restAPI/ProductAPI';
import SubProductAPI from 'restAPI/SubProductAPI';
import Vocabulary from 'components/Vocabulary';
import { PermissionSetMap } from "constants/RBACConstants";
import { hasPermission } from "utils/authService";
import ModalUtil from 'utils/modalUtil';
import ProductFormPopup from 'views/Inventory/Product/ProductFormPopup';
import { parseSelectOptions as globalParseSelectOptions } from 'utils/formUtils';
import SubproductFormPopup from 'views/Inventory/SubProduct/SubproductFormPopup';
import { useActiveUserContext } from 'contexts/ActiveUserContext';
import { useHistory } from 'react-router-dom';

const ProductOrSubProductSelectWithAddButton = ({ dropdownType = 'product', onCreate = _.noop, parseSelectOptions, ...props }) => {
	let productId = props.productId
	if(_.isFunction(props.getProductId) && props.listField) {
		productId = props.productId || props.getProductId(props?.listField?.name)
	}
	const showAddButton = props.showAddButton || Boolean(productId)
	const [selectOptions, setSelectOptions] = useState(null);
	const [open, setOpen] = useState(false);
	const permissionType = (dropdownType === 'product') ? PermissionSetMap.WRITE_PRODUCT : PermissionSetMap.WRITE_SUB_PRODUCT;
	const canAdd = hasPermission(permissionType);
	const activeUser = useActiveUserContext();
	const history = useHistory();
	const [searchText, setSearchText] = useState("");
	useEffect(() => {
		const isSubproduct = dropdownType === 'subProduct';
		if ((isSubproduct && !productId) || props.dontFetchProductSubProduct) {
			setSelectOptions([]);
			return;
		}
		let cancelFn = noop;
		const timeoutId = setTimeout(() => {
			setSelectOptions(null);
			let request;
			if (isSubproduct) {
				request = SubProductAPI.getAllQuick_V2({
					productIds: isArray(productId) ? productId : [productId],
					search: searchText,
				});
			} else {
				request = ProductAPI.getAllQuick_V2({
					search: searchText,
				});
			}

			request.promise.then((res) => {
				let tempOptions = res.data.map(option => ({ label: option.name, value: option.id }));

				if (parseSelectOptions) {
					tempOptions = parseSelectOptions(tempOptions);
				} else {
					tempOptions = globalParseSelectOptions(tempOptions);
				}
				setSelectOptions(tempOptions);
			});


			cancelFn = request.cancel;

		}, 500);
		return () => {
			clearTimeout(timeoutId);
			cancelFn();
		}
	}, [dropdownType, parseSelectOptions, productId, props.dontFetchProductSubProduct, searchText]);

	useEffect(() => {
		if (!open) {
		  setSearchText("");
		}
	  }, [open]);

	const setOptionsAndCallBack = useCallback((createdData) => {
		if (createdData) {
			const currentOptions = selectOptions || [];
			setSelectOptions([{ label: createdData.name, value: createdData.id }, ...currentOptions]);
			!_.isEmpty(createdData) && onCreate(createdData, props.listField)
		}
	}, [selectOptions, onCreate, props.listField]);

	const onButtonClick = useCallback(() => {
		setOpen(false);

		if (dropdownType === 'product') {
			ModalUtil.show({
				content: <ProductFormPopup activeUser={activeUser} />,
				afterClose: setOptionsAndCallBack
			})
		} else if (dropdownType === 'subProduct') {
			ModalUtil.show({
				content: <SubproductFormPopup activeUser={activeUser} productId={productId} history={history} doNotShowSecToolPopUp={true} />,
				afterClose: setOptionsAndCallBack
			});
		}
	}, [setOptionsAndCallBack, activeUser, dropdownType, productId, history]);

	return (
		<CustomSelect
			{...props}
			open={open}
			onDropdownVisibleChange={setOpen}
			placeholder={<>Select <Vocabulary name={dropdownType} /></>}
			loading={_.isNull(selectOptions)}
			options={selectOptions}
			onSearch={setSearchText}
			dropdownRender={menu => (
				<>
					{
						(showAddButton && canAdd)
							?
							<div className="p-xs">
								<Button size="small" name={dropdownType} block type={'dashed'} onClick={onButtonClick}><>Add <Vocabulary name={dropdownType} /></></Button>
							</div>
							:
							null
					}
					{menu}
				</>
			)}
			filterOption={props.dontFetchProductSubProduct ? true : false}
		/>
	)
}

export default ProductOrSubProductSelectWithAddButton;